import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewChild,
  ElementRef,
} from '@angular/core'
import { SiteContext } from '@spartacus/core'
import { Observable } from 'rxjs'
import { SiteContextComponentService } from './site-context-component.service'
import { SiteContextType } from './site-context.model'
import { ICON_TYPE } from '@spartacus/storefront'
import { NgSelectComponent } from '@ng-select/ng-select'

@Component({
  standalone: false,
  selector: 'cx-site-context-selector',
  templateUrl: './site-context-selector.component.html',
  styleUrls: ['./site-context.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SiteContextSelectorComponent {
  siteContextService: SiteContext<any>
  iconTypes = ICON_TYPE
  /**
   * the context type can be set as an input. If the context is
   * not given, the context will be loaded from the backend.
   */
  @Input() context: SiteContextType
  @ViewChild('context') select: NgSelectComponent
  openContectDrp = false
  constructor(private componentService: SiteContextComponentService) {}

  get items$(): Observable<any> {
    return this.componentService.getItems(this.context)
  }

  get activeItem$(): Observable<string> {
    return this.componentService.getActiveItem(this.context)
  }

  set active(value: string) {
    this.componentService.setActive(value, this.context)
  }

  get label$(): Observable<any> {
    return this.componentService.getLabel(this.context)
  }
  openSelect(event) {
    this.select.focus()
    // this.select.nativeElement.focus();
  }
  openContext() {
    this.openContectDrp = !this.openContectDrp
  }
  closeMenu(event) {
    this.openContectDrp = false
  }
}
